<template>
  <v-app>
    <v-main>
      <!-- Background -->
      <div class="form-page">
        <!-- Form Box -->
        <div class="form-box">
          <v-form ref="form" v-model="valid" class="pa-4">
            <h2 class="form-title">Formulaire d'inscription</h2>

            <v-row>
              <!-- Nom complet -->
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="formData.nomComplet"
                  label="Nom complet"
                  outlined
                  dense
                  required
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>

              <!-- Numéro de téléphone -->
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="formData.telephone"
                  label="Numéro de téléphone"
                  outlined
                  dense
                  required
                  :rules="[rules.required, rules.phone]"
                ></v-text-field>
              </v-col>

              <!-- Âge -->
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="formData.age"
                  label="Âge"
                  type="number"
                  outlined
                  dense
                  required
                  :rules="[rules.required, rules.number]"
                ></v-text-field>
              </v-col>

              <!-- Code Apogée -->
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="formData.codeApogee"
                  label="Code Apogée"
                  outlined
                  dense
                  required
                  :rules="[rules.required, rules.onlyNumbers]"
                ></v-text-field>
              </v-col>

              <!-- Filière -->
              <v-col cols="12" md="4">
                <v-select
                  v-model="formData.filiere"
                  :items="filieres"
                  label="Filière"
                  outlined
                  dense
                  required
                  :rules="[rules.required]"
                ></v-select>
              </v-col>

              <!-- Type de Membre -->
              <v-col cols="12" md="4">
                <v-select
                  v-model="formData.clubCategoryId"
                  :items="typeMembres"
                  item-value="id"
                  item-text="name"
                  label="Sélectionnez votre Catégorie"
                  outlined
                  dense
                  required
                  :rules="[rules.required, rules.categoryRequired]"
                ></v-select>
              </v-col>

              <!-- Expérience -->
              <v-col cols="12" md="6">
                <v-textarea
                  class="wi"
                  v-model="formData.experience"
                  label="Expérience"
                  rows="3"
                  outlined
                  dense
                  required
                  :rules="[rules.required]"
                ></v-textarea>
              </v-col>

              <!-- Compétences -->
              <v-col cols="12" md="6">
                <v-textarea
                  class="wi"
                  v-model="formData.competences"
                  label="Compétences"
                  rows="3"
                  outlined
                  dense
                  required
                  :rules="[rules.required]"
                ></v-textarea>
              </v-col>

              <!-- Soumettre -->
              <v-col cols="6" md="4">
                <v-btn block color="primary" class="mt-4" @click="handleSubmit">
                  S'inscrire
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";

export default {
  name: "RegistrationForm",
  setup() {
    const router = useRouter();
    const valid = ref(false);

    const formData = ref({
      nomComplet: "",
      telephone: "",
      age: null,
      filiere: "",
      typeMembre: "",
      codeApogee: "",
      experience: "",
      competences: "",
      clubCategoryId: null, // Ajouté pour correspondre au champ attendu
    });

    const rules = {
      required: (value) => !!value || "Ce champ est requis.",
      phone: (value) =>
        /^(?:\+?\d{1,3}[-.\s]?)?(?:\(?\d{1,4}\)?[-.\s]?)?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
          value
        ) || "Numéro de téléphone invalide",
      number: (value) => !isNaN(value) || "Veuillez entrer un nombre valide.",
      onlyNumbers: (value) =>
        /^\d+$/.test(value) || "Veuillez entrer uniquement des chiffres.",
      categoryRequired: (value) => !!value || "Le type de membre est requis.", // Validation pour clubCategoryId
    };

    const filieres = ref([
      "Informatique",
      "Biologie",
      "Géologie",
      "Physique",
      "Chimie",
    ]);

    const typeMembres = ref([]);

    const fetchTypeMembres = async () => {
      try {
        const response = await axios.get(
          "https://api.mizabook.com/apiopis/mizaclubcats"
        );
        typeMembres.value = response.data;
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des types de membres:",
          error
        );
      }
    };

    const handleSubmit = async () => {
      try {
        const response = await axios.post(
          "https://api.mizabook.com/apiopis/mizabooks",
          {
            fullName: formData.value.nomComplet,
            age: formData.value.age,
            phone: formData.value.telephone,
            filiere: formData.value.filiere,
            codeAppoge: formData.value.codeApogee,
            experience: formData.value.experience,
            competence: formData.value.competences,
            clubCategoryId: formData.value.clubCategoryId, // S'assurer que clubCategoryId est bien envoyé
          }
        );
        formData.value = {
          nomComplet: "",
          telephone: "",
          age: null,
          filiere: "",
          typeMembre: "",
          codeApogee: "",
          experience: "",
          competences: "",
          clubCategoryId: null,
        };

        router.push({ name: "SuccessView" });
        console.log(response);
      } catch (error) {
        console.error(
          "Erreur lors de la soumission:",
          error.response?.data || error
        );
      }
    };

    onMounted(() => {
      fetchTypeMembres(); // Appel pour récupérer les types de membres
    });

    return {
      valid,
      formData,
      filieres,
      typeMembres,
      rules,
      handleSubmit,
    };
  },
};
</script>

<style scoped>
/* Full page background */
.form-page {
  padding-top: 200px;
  background-image: url("@/assets/bg.png");
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  align-items: center;
}

/* Transparent box for the form */
.form-box {
  margin-left: 5%;
  width: 90%;
  background-color: rgba(255, 255, 255, 0.4);
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
}

.form-title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 1.5rem;
  color: #333;
}

.v-btn {
  margin-left: 100%;
  transition: all 0.3s ease;
  font-weight: bold;
  letter-spacing: 1px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.v-btn:hover {
  background-color: #4caf50 !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transform: translateY(-2px);
}

.v-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}
@media (max-width: 959px) {
  .form-box {
    margin-top: -100px;
  }
  .v-btn {
    margin-left: 50%;
  }
}
</style>
